<template>
<div class="chapter">
<div class="inner_page">
<div class="blockquote">
<div class="blockquote1">
<p class="noindent">He lifts his fingers toward the skies</p>
<p class="noindent">Where holy brightness breaks in flame;</p>
<p class="noindent">Radiance reflected in his eyes,</p>
<p class="noindent">And on his lips a whispered name.</p>
<p class="space-break" style="margin-left:3em;">‘How To Die’, Siegfried Sassoon</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface003.vue?ab196642